import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import CloseIcon from '@mui/icons-material/Close'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { closePopup } from '../../actions/uiActions'

function InfoDbJob(props) {
    function handleClick(event) {
        event.preventDefault()
        props.closePopup()
    }

    // This is the render logic, no need to declare another method is a functional component
    return (<Dialog
        open={true}
        onClose={handleClick}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <CloseIcon onClick={handleClick} className="closePoup" />
        <DialogTitle id="alert-dialog-title" className="changepassdialog">
            {props.popupInfo.header}
            {' '}
        </DialogTitle>
        <DialogContent>
            <p>{props.popupInfo.message}</p>
        </DialogContent>
    </Dialog>)
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InfoDbJob)